/* eslint-disable @typescript-eslint/no-wrapper-object-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {defaultAutoSinistreError} from '../../data/constants/Sinistres/autoMoto';
import {IError} from '../../data/types/interface/Sinistres/autoMoto';
import {
  MESSAGE_VALIDATION,
  NUM_IMMATRICULATION,
  TELEPHONE_VALIDATION,
} from './validation';

const listRequiredField = (
  required: Array<any>,
  notRequired: Array<String>,
) => {
  const aResult = required.filter(elt => !notRequired.includes(elt[0]));
  return aResult;
};

export const Validation = (values: IError, listAgence?: []) => {
  let errors: IError = {...defaultAutoSinistreError};
  const aNotRequiredField = ['pieceJointeAgence'];
  const aRequiredField = listRequiredField(
    Object.entries(values),
    aNotRequiredField,
  );

  /** numéro immatriculation checking */
  if (NUM_IMMATRICULATION.test(values.immatriculation)) {
    errors.immatriculation = MESSAGE_VALIDATION.invalidImmatriculation;
  }

  /** agence cheking */
  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values.agence.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.invalidAgence;
    }
  }

  /** telphone cheking */
  if (!TELEPHONE_VALIDATION.test(values.telephone)) {
    errors.telephone = MESSAGE_VALIDATION.requiredTelephone;
  }

  if (values.photo.length < 1) {
    errors.photo = 'Choisir au moins une photo';
  } else {
    errors.photo = '';
  }

  /** checking all required values */
  aRequiredField.forEach(element => {
    if (
      element[1] === '' ||
      element[1] === null ||
      (Array.isArray(element[1]) && element[1].length === 0)
    ) {
      errors = {...errors, [element[0]]: 'Ce champ est obligatoire'};
    }
  });

  return errors;
};
